import { render, staticRenderFns } from "./TechReceived.vue?vue&type=template&id=75261680&"
import script from "./TechReceived.vue?vue&type=script&lang=js&"
export * from "./TechReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports